<template>
  <div>
    <p>不好，404啦！</p>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
</style>